module.exports = __webpack_public_path__ + "static/EPD-lamppost-desktop_backg_png8-a6ae717d10acab994e10003b1799e02a.png";